import React, { useState } from "react";
import {
  Grid,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack, Error } from "@mui/icons-material";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import GetInvoiceTable from "./reportTables/GetInvoiceTable.js";
import LongOutStandingTable from "./reportTables/LongOutStandingTable.js";

const useStyles = makeStyles(dashboardStyle);
const commentBox = {
  fontFamily: "DM Sans,sans-serif",
  fontWeight: "400",
  fontSize: "0.875rem",
  width: "100%",
  border: "1px solid #b4b4b4",
  borderRadius: "2px",
  resize: "none",
  overflow: "hidden",
  outline: "none",
  height: "40px",
  marginTop: "1px",
  color: "black",
};
const headers = [
  { label: "BarCode No", key: "barCodeNo" },
  { label: "Invoice No", key: "invoiceNo" },
  { label: "Vendor Name", key: "vendorName" },
  { label: "Invoice Type", key: "invoiceType" },
  { label: "Days outstanding ", key: "daysOutStanding" },
  { label: "Payment Term", key: "paymentTerm" },
  { label: "Due Date", key: "due_Date" },
  { label: "Invoice Date", key: "invoice_Date" },
  { label: "Stage of I2P", key: "stageOfI2P" },
  { label: "Pending with-(User name)", key: "pendingWith" },
  { label: "days remaining to sales tax lapse", key: "daysTaxLaps" },
  { label: "remaining credit days", key: "remainingCreditDays" },
];

export default function LongOutStandingReport() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendloader, setSendloader] = useState(false);

  const [countNo, setCountNo] = React.useState(1); // Set default page to 0

  return (
    <div>
      {" "}
      <>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={sendloader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Card style={{ marginLeft: "20px" }}>
          <CardHeader color="primary" text>
            <CardText
              style={{
                padding: "1px 27px",
                backgroundColor: "#031C30",
                color: "white",
                height: "62px",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <h4> Long OutStanding Invoices </h4>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <IconButton
                    variant="contained"
                    style={{ float: "right", marginTop: "1.5%" }}
                    onClick={() => navigate("/home")}
                  >
                    <ArrowBack
                      style={{ color: "#fff" }}
                      titleAccess="Go Back"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </CardText>
          </CardHeader>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <LongOutStandingTable
              loading={loading}
              setCountNo={setCountNo}
              header={headers}
              data={data}
              dropdownValue={"InvoiceStatus"}
              setData={setData}
              setLoading={setLoading}
            />
          </Grid>
        </Card>
      </>
    </div>
  );
}
